import * as React from "react";
const CheckboxChecked = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 10 8", fill: "currentColor", width: size || "10", height: size || "8", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.5 5.2 1.2 3 0 4.2 3.5 7.8 10 1.2 8.8 0z" }));
CheckboxChecked.displayName = "CheckboxChecked";
var CheckboxChecked_default = CheckboxChecked;
export {
  CheckboxChecked_default as default
};
